<template>
    <div>
		<div v-if="mode == 'full'">
			<div class="library-book-page-controller preloader" v-if="!loaded">
			</div>
			<div class="library-book-page-controller" v-else>
				<div class="page-controller-heading" :style="{'color': book.cover_color, 'borderColor': book.cover_color}">
					Содержание
				</div>
				<div class="page-controller-notice" v-if="notice">
					<div class="page-controller-icon">
					</div>
					<div class="page-controller-text">
						<div class="page-controller-notice-heading">
							Совет
						</div>
						<div class="page-controller-notice-description">
							Вы можете выбрать нужную главу для быстрого перемещения к ней
						</div>
					</div>
					<div class="page-controller-notice-close" @click="closeNotice()">
					</div>
				</div>
				<div class="controller-list">
					<ol class="controller-list-items" ref='list'>
						<li 
							class="controller-list-items-item"
							v-for="(chapter, index) in book.chapters" 
							:key="index" 
							:class="{active: navigation.active === chapter.id}"
							@click="setActiveChapter(chapter.id)"
						>
							<span
								v-if="navigation.active === chapter.id"
								v-html="chapter.title"
								:style="{'color': book.cover_color}"
							>
							</span>
							<span
								v-else
								v-html="chapter.title"
							>
							</span>
						</li>
					</ol>
				</div>
				<div class="controller-controlls">
					<div class="controller-controlls-button controll-before"
						:class="{inactive: navigation.prev === false}" 
						@click="setActiveChapter(navigation.prev)"
					></div>
					<div class="controller-controlls-current">
						<div class="current-title">Текущая глава:</div>
						<div class="current-item" v-html="(navigation.active+1)+'/'+(book.chapters.length)+' '+book.chapters[navigation.active].title"></div>
					</div>
					<div
						class="controller-controlls-button controll-after"
						:class="{inactive: navigation.next === false}" 
						@click="setActiveChapter(navigation.next)"
					>
					</div>
				</div>
			</div>
		</div>
		<div v-if="mode == 'compact'">
			<div v-if='loaded' class="controller-controlls-min">
				<div class="controller-controlls-button controll-prev"
					v-if="navigation.prev !== false"
					@click="setActiveChapter(navigation.prev)"
				></div>
				<div class="controller-controlls-button controll-next"
					v-if="navigation.next !== false"
					@click="setActiveChapter(navigation.next)"
				>	
					<div>
						<div class="current-title">Читать далее:</div>
						<div class="current-item" v-html="(navigation.next+1)+'/'+(book.chapters.length)+' '+book.chapters[navigation.next].title"></div>
					</div>
					<div class="icon-next">
					
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import store from "../../store/";


export default {
    name: "LibraryBookController",
	store,
	data() {
		return {
			notice: true,
		}
	},
	props: ['mode'],
	created() {	
		this.notice = this.$ls.get('showNotice', true, Boolean);
		
		setTimeout(() => {
		
			if (this.navigation.active > 0){
				window.scroll({ top: window.innerHeight, left: 0, behavior: "smooth" });
			}else {
				window.scroll({ top: 0, left: 0})
			}
		}, 500);
		
	},
	updated() {
		if (this.loaded && this.mode === 'full'){
			this.scrollList();
		}
	},
    computed: {
		loaded() {
			return this.$store.state["LibraryBook"].loaded;
		},
        book() {
			return this.$store.state["LibraryBook"].book;
		},
		navigation() {
			return this.$store.state["LibraryBook"].navigation;
		}
    },
    methods: {
        setActiveChapter(chapter){
			if (chapter !== false) {
				this.$store.dispatch("LibraryBook/updateNavigation", {
			    	activeChapterId: chapter
		   		})

				if (!this.book.cover_display) {
					window.scroll({ top: 0, left: 0, behavior: "smooth" });
				} else {
					window.scroll({ top: window.innerHeight, left: 0, behavior: "smooth" });
				}

				window.history.pushState(null, null, chapter+1);
			}
        },
		scrollList() {
			let activeListItem = this.$refs.list.children[this.navigation.active];
			this.$refs.list.scroll({top: activeListItem.offsetTop - 40, left: 0, behavior: "smooth" });
			
			
		},
		closeNotice() {
			this.notice = this.$ls.set('showNotice', false, Boolean);
		}
    },
}
</script>


// WEBPACK FOOTER //
// src/components/LibraryBookController/index.vue